export default {
  'Custom': 'カスタム',
  'Original': 'オリジナル',
  'Resolution': '解像度',
  'Frame rate': 'フレームレート',
  'The higher the frame rate, the smoother the animation': 'フレームレートが高いほど、アニメーションが滑らかになります。',
  'Start': '開始',
  'End': '終了',
  'Create GIF': 'GIF作成',
  'Download GIF': 'GIFダウンロード',
  'Create A New One': '新しいGIFを作る',
  'Remake GIF': 'GIFを作り直す',
  'HitPaw Video to GIF Online': 'オンラインで動画をGIFに変換',
  'Upload and convert video to GIF without any difficulty': '難しい操作なしで動画をGIFファイルに変換できます',
}